export enum GipProducts {
  Proxima = "proxima",
  ProximaPlus = "proximaPlus",
  Momento = "momento",
  Integral100 = "integral100k",
  Integral180 = "integral180k",
  Integral240 = "integral240k",
}